import {
  CircleAlert,
  CircleCheck,
  CircleDashed,
  FileCheck,
  TriangleAlert,
} from "lucide-react";
import React from "react";

import { cn } from "@/lib/utils";
import type { InvoiceReadiness } from "@/types/api";

interface Props {
  readiness: InvoiceReadiness;
  createdNumber?: string | null;
  className?: string;
}

const CONFIG: Record<
  InvoiceReadiness,
  {
    label: string;
    Icon: typeof CircleCheck;
    tone: "green" | "amber" | "red" | "muted";
  }
> = {
  ready: { label: "Готов", Icon: CircleCheck, tone: "green" },
  created: { label: "Создан", Icon: FileCheck, tone: "green" },
  needs_nomenclature: {
    label: "Нужно сопоставить",
    Icon: CircleDashed,
    tone: "amber",
  },
  incomplete_mapping: {
    label: "Незавершён маппинг",
    Icon: TriangleAlert,
    tone: "amber",
  },
  parse_error: { label: "Ошибка разбора", Icon: CircleAlert, tone: "red" },
};

export function InvoiceStatusChip({
  readiness,
  createdNumber,
  className,
}: Props): React.ReactElement {
  const cfg = CONFIG[readiness];
  const toneClass =
    cfg.tone === "green"
      ? "text-green-700"
      : cfg.tone === "amber"
        ? "text-amber-600"
        : cfg.tone === "red"
          ? "text-destructive"
          : "text-muted-foreground";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium",
        toneClass,
        className,
      )}
    >
      <cfg.Icon className="size-4" />
      {readiness === "created" && createdNumber ? createdNumber : cfg.label}
    </span>
  );
}
